<template>
    <Modal
        :opened="isOpen"
        :title="$t('filters.presets.delete.modal.title')"
        :dissmisable="true"
        class="DeletePresetModal"
        @close="closeModal"
    >
        <template #body>
            <div class="DeletePresetModalBody">
                <WText
                    :size="16"
                    color="gray01"
                    class="DeletePresetWarning"
                >
                    {{ $t('filters.presets.delete.modal.warning', { searchLabel: selectedPreset.label }) }}
                </WText>
                <div class="DeletePresetButtons">
                    <WButton
                        outline
                        color="accent-blue"
                        @click="closeModal"
                    >
                        {{ $t('filters.presets.delete.modal.cancel') }}
                    </WButton>
                    <WButton
                        @click="deletePreset"
                    >
                        {{ $t('filters.presets.delete.modal.accept') }}
                    </WButton>
                </div>
            </div>
        </template>
    </Modal>
</template>

<script>
import VueTypes from 'vue-types'
import { Api, apiRequest } from '@/api'
import { Modal } from '@/components'

export default {
    name: 'DeletePresetModal',
    components: { Modal },
    props: {
        isOpen: VueTypes.bool,
        selectedPreset: VueTypes.object,
    },
    methods: {
        closeModal () {
            this.$emit('close')
        },
        deletePreset () {
            apiRequest(Api().presets.deleteById(this.selectedPreset.key))
                .then(() => {
                    this.$emit('refreshPresets')
                    this.closeModal()
                })
        },
    },
}
</script>

<style lang="scss" scoped>
.DeletePresetModal {
    .DeletePresetModalBody {
        .DeletePresetWarning {
            margin-bottom: 15px;
        }
        .DeletePresetButtons {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            margin-top: 20px;
        }
    }
}
</style>
